export default __webpack_public_path__ + "static/media/Category-Sensory-transparent.94491a79.png";